/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Model to represent a IndustryScenarioDTO from the API.
 * Contains attributes from the IndustryScenario table.
 *
 */
export class IndustryScenario {
  id: number;
  industryScenarioName: string;
  industryScenarioAssumption: string;
  forecastOrganization: string;
  industryScenarioCategory: string;
  industryScenarioType: string;
  schemaDefault: string;
  isEditLocked: boolean;
  isDeleteLocked: boolean;
  userId: string;
  timeStamp: string;
  createdBy: string;
  isHidden: boolean;

}
